/**
 * Derive the parent frame's origin at mount time from `document.referrer`.
 * Returns `"*"` when the referrer is absent or unparseable (e.g. test
 * environments, direct navigation).
 */
export function resolveParentOriginFromReferrer(): string {
  if (typeof document === "undefined") return "*";
  try {
    return document.referrer ? new URL(document.referrer).origin : "*";
  } catch {
    return "*";
  }
}

let narrowedParentOrigin: string | undefined;

/**
 * Remember the parent origin from a validated inbound postMessage.
 * Ignores empty or opaque `"null"` origins.
 */
export function tightenParentPostMessageOrigin(origin: string): void {
  if (!origin || origin === "null") {
    return;
  }

  narrowedParentOrigin = origin;
}

/**
 * Target origin for outbound postMessages to the embedder.
 * Prefers a narrowed origin from validated inbound traffic, then
 * `document.referrer`, then `"*"`.
 */
export function getParentPostMessageOrigin(): string {
  return narrowedParentOrigin ?? resolveParentOriginFromReferrer();
}

/** Clears narrowed origin between tests. */
export function resetParentPostMessageOriginForTests(): void {
  narrowedParentOrigin = undefined;
}
